import { MindmapNodeOrientation } from "shared/datamodel/schemas/mindmap";
import ToggleButton from "./toggle-button";
import style from "./mindmapOrientationPicker.module.css";
import { Icon } from "../toolbar-buttons";

export default function MindmapOrientationPicker({
  value,
  onChange,
}: {
  value: MindmapNodeOrientation;
  onChange: (orientation: MindmapNodeOrientation) => void;
}) {
  return (
    <div className={style.container} data-testid="MindmapOrientation">
      <ToggleButton
        isOn={value === MindmapNodeOrientation.HORIZONTAL}
        onClick={() => onChange(MindmapNodeOrientation.HORIZONTAL)}
        tooltip={"Vertical"}
        className={style.button}
      >
        <Icon icon="icon-horizontal-mindmap" />
      </ToggleButton>
      <ToggleButton
        isOn={value === MindmapNodeOrientation.VERTICAL}
        onClick={() => onChange(MindmapNodeOrientation.VERTICAL)}
        tooltip={"Horizontal"}
        className={style.button}
      >
        <Icon icon="icon-vertical-mindmap" />
      </ToggleButton>
    </div>
  );
}
